import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router/dom'
import { AppProviders } from './app/providers'
import { router } from './app/router'
import { IS_MOCK } from './lib/env'
import './index.css'

/**
 * In mock mode (dev environment) the MSW service worker boots before the app
 * so the very first session bootstrap request is already intercepted. test
 * and prod call the real service — see src/lib/env.ts.
 */
async function enableMocking(): Promise<void> {
  if (!IS_MOCK) return
  const { worker, consumeMockLoginMarker } = await import('./mocks/browser')
  consumeMockLoginMarker()
  await worker.start({ onUnhandledRequest: 'bypass' })
}

void enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AppProviders>
        <RouterProvider router={router} />
      </AppProviders>
    </StrictMode>,
  )
})
